import { RootState } from '@/store/types'
import {
  SpirApplication,
  SpirApplicationsState,
} from '@/store/applications/spir/types'
import axios from 'axios'
import { ActionTree } from 'vuex'
import _ from 'lodash'

const actions: ActionTree<SpirApplicationsState, RootState> = {
  /**
   * SPIR申請取得
   *
   * @param {string} applicationId 申請ID
   */
  getSpirApplication: (
    { commit, dispatch, getters },
    { applicationId }: { applicationId: string },
  ) => axios.get(`/applications/spir/${applicationId}`).then(async ({ data }) => {
    await Promise.all([
      dispatch('getStudentById', { studentId: data.studentId }),
      dispatch('getGroupById', { groupId: data.groupId }),
    ])

    const application: SpirApplication = {
      id: applicationId,
      type: 'spir',
      fromGroup: getters.findGroupById(data.groupId),
      student: getters.findStudentById(data.studentId),
      comment: data.comment,
      applicant: {
        id: data.applicantId,
        name: data.applicantName,
      },
      status: data.status,
      approvedComment: _(data.events).maxBy('date')?.comment || null,
      targetTutor: getters.findTutorById(data.tutorId),
    }

    commit('gotSpirApplication', application)
  }),

  /**
   * SPIR申請登録
   * @param context
   * @param {SpirApplication} payload 申請内容
   */
  registerSpirApplication: (
    {
      rootState,
    },
    {
      student,
      fromGroup,
      comment,
    }: SpirApplication,
  ) => axios.post('/applications/spir', _.pickBy({
    tutorId: fromGroup.tutor.id,
    groupId: fromGroup.id,
    studentId: student.id,
    comment,
  })),
}

export default actions
